import React from 'react';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Alert, Box, Typography } from '@mui/material';

import { classes } from './styles';

interface InfoAlertProps {
  ariaLabel?: string;
  messageHtml: string;
}

export const InfoAlert: React.FC<InfoAlertProps> = ({
  ariaLabel = 'Job status notice',
  messageHtml
}) => (
  <Box aria-label={ariaLabel} component="section" sx={classes.preview.containerSx()}>
    <Alert
      aria-live="polite"
      icon={<InfoOutlinedIcon />}
      role="status"
      severity="info"
      sx={classes.preview.infoBannerSx()}
    >
      <Typography
        component="div"
        dangerouslySetInnerHTML={{ __html: messageHtml }}
        sx={[
          classes.preview.infoBannerTextSx(),
          {
            '& a': {
              color: 'inherit',
              textDecoration: 'underline',
              textUnderlineOffset: '2px'
            }
          }
        ]}
      />
    </Alert>
  </Box>
);

export default InfoAlert;
